import React from 'react'
import { useLocation } from 'react-router-dom'
import Link from 'components/Link'
import clsx from 'clsx'

const MAIN_NAV = [
    { label: 'System', href: '/superadmin/system', match: '/superadmin/system' },
    { label: 'Tenants', href: '/superadmin/tenants', match: '/superadmin/tenants' },
    { label: 'Users', href: '/superadmin/users', match: '/superadmin/users' },
]

function isActive(pathname, match) {
    if (match === '/superadmin/tenants') {
        return pathname.startsWith('/superadmin/tenants')
    }
    return pathname === match || pathname.startsWith(`${match}?`)
}

export function SuperAdminNav() {
    const location = useLocation()

    return (
        <nav className="superadmin-sidebar">
            <div className="superadmin-sidebar-title">Navigation</div>
            {MAIN_NAV.map(item => (
                <Link
                    key={item.href}
                    href={item.href}
                    className={clsx(
                        'superadmin-nav-item',
                        isActive(location.pathname, item.match) && 'superadmin-nav-item--active'
                    )}
                >
                    {item.label}
                </Link>
            ))}
        </nav>
    )
}
